interface AppealSummaryTab {
  id: string;
  label: string;
}

interface AppealSummaryTabBarProps {
  tabs: AppealSummaryTab[];
  activeTabId: string;
  onTabChange: (tabId: string) => void;
}

/** Shared classes for every tab button. */
const TAB_CLASSES =
  "cursor-pointer border-0 border-b-2 border-solid bg-transparent px-4 py-2 text-small font-semibold transition-colors duration-200";

/**
 * Underlined tab bar shared by both panes of the appeal summary modal.
 *
 * @param props.tabs - Tabs to render, in display order
 * @param props.activeTabId - Id of the currently selected tab
 * @param props.onTabChange - Called with the id of the tab the user selects
 */
const AppealSummaryTabBar = (props: AppealSummaryTabBarProps) => (
  <div className="flex shrink-0 border-b border-primaryGray-15">
    {props.tabs.map((tab) => (
      <button
        key={tab.id}
        type="button"
        className={`${TAB_CLASSES} ${
          props.activeTabId === tab.id
            ? "border-blue-600 text-blue-600"
            : "border-transparent text-primaryGray-6 hover:text-primaryGray-3"
        }`}
        onClick={() => props.onTabChange(tab.id)}
      >
        {tab.label}
      </button>
    ))}
  </div>
);

export default AppealSummaryTabBar;
